export default {
  namespaced: true,
  state: {
    timelineEntries: [],
    timelineLoading: false,
  },
  mutations: {
    SET_TIMELINE_ENTRIES(state, data) {
      state.timelineEntries = data;
    },
    SET_TIMELINE_LOADING(state, val) {
      state.timelineLoading = val;
    },
  },
  actions: {
    getTimeline({ commit }, { userId, size = 5 }) {
      const vm = this;
      commit("SET_TIMELINE_LOADING", true);
      return vm.$http
        .get(`basic-timeline?user_id=${userId}&size=${size}`)
        .then((res) => {
          const entries = (res.data.data || []).slice(0, size);
          commit("SET_TIMELINE_ENTRIES", entries);
          commit("SET_TIMELINE_LOADING", false);
          return entries;
        })
        .catch(() => {
          commit("SET_TIMELINE_ENTRIES", []);
          commit("SET_TIMELINE_LOADING", false);
        });
    },
  },
};
